// ---------------------------------------------------------------------------
// [N-11] Registro de errores en el navegador, acotado por entorno.
//
// El problema: volcar el error completo con console.log(e) imprime en la
// consola del navegador el objeto entero, que puede arrastrar contenido
// clinico (el texto de un dictado, datos del paciente) o detalle interno del
// backend. En un PC de clinica compartido cualquiera lo lee abriendo DevTools.
//
// Pero el silencio tampoco sirve: tragarse los errores ya escondio fallos
// reales antes (ver el comentario de VideoConsulta.js, el limite de rate que
// paso desapercibido). Por eso:
//   - en desarrollo: el error completo, como siempre (depurar sin fricción).
//   - en produccion: UNA linea minima y no sensible - codigo HTTP si lo hay, o
//     el nombre del tipo de error. Suficiente para saber que algo fallo y de
//     que clase, sin exponer el contenido.
//
// Uso: logError(e) en lugar de console.log(e) / console.error(e).
// ---------------------------------------------------------------------------

const esProduccion = () => process.env.NODE_ENV === 'production';

/** Resumen no sensible del error: solo tipo/codigo, nunca cuerpo ni datos. */
const resumen = (e) => {
    if (!e) return 'error desconocido';
    const status = e.response && e.response.status;
    if (status) return `HTTP ${status}`;
    return e.name || 'Error';
};

export const logError = (e) => {
    if (esProduccion()) {
        // Sin el objeto: solo la señal de que hubo un fallo y de que tipo.
        console.error('[error]', resumen(e));
        return;
    }
    console.error(e);
};

export default logError;
